import LastTableCell from '@framework/ui/Molecules/Tables/TableWrapper/LastTableCell';
import IconDownload from '@creditflowresearch/uilib/Icon/IconDownload';
import IconButton from '@creditflowresearch/uilib/IconButton';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { formatDateOrTime } from '@/creditflowresearch/ui/components/ActiveCalendar/helpers/dates';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import useDownloadAttachment from '@/creditflowresearch/application/ArticlesAndStats/useDownloadAttachment';

import styles from './statsTile.module.scss';

interface IDateCellProps {
  row: {
    updatedAt: string,
    attachment: { uploadId: string, displayName: string } | null,
  },
}

const DateCell = ({ row: { updatedAt, attachment } }: IDateCellProps) => {
  const { downloadAttachment } = useDownloadAttachment();
  const { timeZone } = useUserTimeZoneContext();
  const updatedAtDate = updatedAt ? formatDateOrTime(updatedAt, timeZone, MONTH_DAY_YEAR_FORMAT, true) : '-';

  if (!attachment) {
    return <>{ updatedAtDate }</>;
  }

  return (
    <LastTableCell
      childrenToShowOnHover={ (
        <Tooltip content="Download">
          <IconButton
            icon={ <IconDownload className={ styles.downloadIcon } /> }
            className={ styles.downloadButton }
            ariaLabel={ `Download ${ attachment.displayName }` }
            dataTest="downloadAttachment"
            onClick={ () => downloadAttachment({
              displayName: attachment.displayName,
              uploadId: attachment.uploadId,
            }) }
          />
        </Tooltip>
      ) }
    >
      { updatedAtDate }
    </LastTableCell>
  );
};

export default DateCell;
